import { Pipe, PipeTransform } from '@angular/core';
import {OdometroHorimetroService} from "../../manutencoes/odometros-horimetros/shared/odometro-horimetro.service";

@Pipe({
    name: 'odometroHorimetroMask'
})
export class OdometroHorimetroMaskPipe implements PipeTransform {

    constructor(
        private _odometroHorimetroService: OdometroHorimetroService
    ){}

    transform(value: any, args?: any): any {
        if (value) {
            value = this._odometroHorimetroService.setMask(value);
            return value;
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/odometro-horimetro-mask.pipe.ts
 **/